<app-retailer-top-bar [showBackArrow]="true"
                      [previousPage]="'/retailer/select-vehicle-model'"
                      (onNewStudio)="onNewStudio()"></app-retailer-top-bar>
<div class="px-10 text-white">
    <div class="py-1">
        <h1 class="text-3xl">{{ vehicleModel?.label }}</h1>
    </div>
    <div class="grid grid-cols-5">
        <div class="col-span-1 flex flex-col">
            <p class="text-light-gray text-lg mb-5">{{ vehicleModel?.modelSeries }}</p>

            <div class="flex items-center mb-3 w-full gap-2">
                <label class="mb-switch cursor-pointer shrink-0 ml-4">
                    <input
                            type="checkbox"
                            [(ngModel)]="isManufakturExclusiveSwitchOn"
                            (ngModelChange)="onSwitchChange('exclusive')"
                    />
                    <span class="switch-bg"></span>
                    <span class="switch-circle"></span>
                </label>
                <p class="flex-1 leading-tight">Manufaktur Exclusive</p>
            </div>

            <div class="flex items-center mb-3 w-full gap-2">
                <label class="mb-switch cursor-pointer shrink-0 ml-4">
                    <input
                            type="checkbox"
                            [(ngModel)]="isManufakturSwitchOn"
                            (ngModelChange)="onSwitchChange('manufaktur')"
                    />
                    <span class="switch-bg"></span>
                    <span class="switch-circle"></span>
                </label>
                <p class="flex-1 leading-tight">Manufaktur</p>

            </div>

            <div class="flex items-center w-full gap-2">
                <label class="mb-switch cursor-pointer shrink-0 ml-4">
                    <input
                            type="checkbox"
                            [(ngModel)]="isStandardSwitchOn"
                            (ngModelChange)="onSwitchChange('standard')"
                    />
                    <span class="switch-bg"></span>
                    <span class="switch-circle"></span>
                </label>
                <p class="flex-1 leading-tight">Standard</p>
            </div>
            <div class="flex flex-col gap-3 my-10">
                @for (brand of brands; track brand) {
                    @if (availableBrandIds.indexOf(brand.id) !== -1) {
                        <div
                                (click)="selectBrand(brand)"
                                [class.selected]="brand === selectedBrand"
                                class="brand-select-box cursor-pointer">
                            <div class="flex justify-center pt-5 pb-3">
                                <img
                                        [src]="brand?.image?.content?.preview?.cloudfrontUrl || 'assets/images/brand_fallback.png'"
                                        alt="Brand Image"
                                        class="rounded-full w-14 h-14">
                            </div>
                            <div class="flex justify-center mb-5">
                                <h1 class="text-2xl">{{ brand?.label }}</h1>
                            </div>
                        </div>
                    }
                }
            </div>

        </div>
        <div class="col-span-4 ">
            <img class="w-full"
                 [src]="vehicleModel?.image?.content?.preview?.cloudfrontUrl || 'assets/images/vehicle_fallback.png'"
                 alt="Vehicle Model Image">
        </div>
    </div>
</div>
